import { postData } from '../helpers/ajax'

export default function bookmark () {
  const bookmarkButtons = document.querySelectorAll('.js-bookmark')

  bookmarkButtons.forEach((bookmarkButton) => {
      bookmarkButton.addEventListener('click', async (evt) => {
        evt.preventDefault()
        const formData = new FormData()
        let response
        if (bookmarkButton.classList.contains('js-chapter-add-bookmark')) {
          formData.append('action', 'add_post_bookmark')
          formData.append('post_id', evt.target.dataset.postid)
          response = await postData(barnafrid.ajax_url, formData)
          if (response.success === true) {
            bookmarkButton.classList.add('Bookmark--saved')
            bookmarkButton.classList.remove('js-chapter-add-bookmark')
            bookmarkButton.classList.add('js-chapter-remove-bookmark')
            bookmarkButton.setAttribute('aria-label', bookmarkButton.dataset.labelBookmarked)
          }
        } else if (bookmarkButton.classList.contains('js-chapter-remove-bookmark')) {
          formData.append('action', 'remove_post_bookmark')
          formData.append('post_id', evt.target.dataset.postid)
          response = await postData(barnafrid.ajax_url, formData)
          if (response.success === true) {
            if (bookmarkButton.parentNode.classList.contains('SavedBookmark')) {
              bookmarkButton.parentNode.classList.add('SavedBookmark--remove')
              setTimeout(() => {
                bookmarkButton.parentNode.remove()
              }, 500)
            } else {
              bookmarkButton.classList.remove('Bookmark--saved')
              bookmarkButton.classList.remove('js-chapter-remove-bookmark')
              bookmarkButton.classList.add('js-chapter-add-bookmark')
              bookmarkButton.setAttribute('aria-label', bookmarkButton.dataset.labelBookmark)
            }
          }
        } else if (bookmarkButton.classList.contains('js-reference-add-bookmark')) {
          formData.append('action', 'add_reference_bookmark')
          formData.append('reference_id', evt.target.dataset.referenceid)
          response = await postData(barnafrid.ajax_url, formData)
          if (response.success === true) {
            bookmarkButton.classList.add('Bookmark--saved')
            bookmarkButton.classList.remove('js-reference-add-bookmark')
            bookmarkButton.classList.add('js-reference-remove-bookmark')
            bookmarkButton.setAttribute('aria-label', bookmarkButton.dataset.labelBookmarked)
          }
        } else if (bookmarkButton.classList.contains('js-reference-remove-bookmark')) {
          formData.append('action', 'remove_reference_bookmark')
          formData.append('reference_id', evt.target.dataset.referenceid)
          response = await postData(barnafrid.ajax_url, formData)
          if (response.success === true) {
            if (bookmarkButton.parentNode.parentNode.classList.contains('SavedReference')) {
              bookmarkButton.parentNode.parentNode.classList.add('SavedReference--remove')
              setTimeout(() => {
                bookmarkButton.parentNode.parentNode.remove()
              }, 500)
            } else {
              bookmarkButton.classList.remove('Bookmark--saved')
              bookmarkButton.classList.remove('js-reference-remove-bookmark')
              bookmarkButton.classList.add('js-reference-add-bookmark')
              bookmarkButton.setAttribute('aria-label', bookmarkButton.dataset.labelBookmark)
            }
          }
        }
      })
    }
  )
}
